import { ReactNode } from "react"
import { TableView } from "./TableView"

export {
    TableView
}

export interface ColumnDefinition<T extends object> {
    Property: (keyof T & string) 
    Title?: string
    Sortable?: boolean,
    sortFn?: (a: T, b: T) => number
    Render?: (item: T) => ReactNode
}



export default TableView